jQuery($ => {

    class GoogleMap {
        constructor(element) {
            this._ = element;
            this._element = $(element);
            this._map = this._element.find('#map');
            this._markers = this._element.find('.m-google-map__marker');
            this.map = null;

            this.init();
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        init() {
            this.setupHandlers();
            this._element.trigger('init', this);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupHandlers() {
            $(document).ready(() => {
                this.initMap(this._map);
            });
        }

        initMap = ($el, $markers = false) => {
            // Find marker elements within map.
            var $markers = $el.find('.m-google-map__marker');

            const styles = [
                {
                    "featureType": "all",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#989898"
                        },
                        {
                            "lightness": "1"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "lightness": "1"
                        },
                        {
                            "weight": "10.00"
                        },
                        {
                            "gamma": "5.03"
                        },
                        {
                            "saturation": "1"
                        },
                        {
                            "color": "#f7f7f7"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f7f7f7"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dedede"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": "1"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": "1"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "weight": "1.00"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#abd0e7"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                }
            ];

            // // Set initial map boundaries
            // const BOUNDS = {
            //   north: 49.3844, // Northernmost latitude
            //   south: 24.3963, // Southernmost latitude
            //   west: -125.0000, // Westernmost longitude
            //   east: -66.9346   // Easternmost longitude
            // };

            const CAPITAL = { lat: 39.7691, lng: 86.1580 };

            // Create generic map
            var mapArgs = {
                zoom: 10,
                mapTypeID: google.maps.MapTypeId.ROADMAP,
                styles: styles,
                streetViewControl: false,
                rotateControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                center: CAPITAL,
                restriction: {
                    // latLngBounds: BOUNDS,
                    strictBounds: false
                }
            };

            this.map = new google.maps.Map($el[0], mapArgs);

            // Add me
            if (GOOGLEMAP.me) {
                this.map.me = new google.maps.Marker({
                    position: {
                        lat: parseFloat(GOOGLEMAP.me['lat']),
                        lng: parseFloat(GOOGLEMAP.me['lng'])
                    },
                    map: this.map,
                });
            }
            // Add markers.
            this.map.markers = [];

            if (this.map.me) {
                this.map.markers.push(map.me);
            }

            $markers.each((_, _marker) => {
                this.initMarker($(_marker));
            });

            this.initClusters(this.map.markers, this.map);

            // Center map based on markers.
            this.centerMap();

            // Return map instance. 
            return this.map;
        }

        initClusters = ($markers, map) => {
            const icon = window.btoa(`<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">
                <g id="map-cluster" transform="translate(4754 184)"> 
                  <circle id="bottom-circle" cx="64" cy="64" r="64" transform="translate(-4754 -184)" fill="rgba(30,56,105 ,0.3)"/>
                  <circle id="mid-circle" cx="54" cy="54" r="54" transform="translate(-4744 -174)" fill="rgba(30,56,105,0.4)"/>
                  <circle id="top-circle" cx="44" cy="44" r="44" transform="translate(-4734 -164)" fill="#1e3869"/>
                </g>
            </svg>`);

            new markerClusterer.MarkerClusterer({
                markers: $markers,
                map: map,
                renderer: {
                    render: ({ count, position }) =>
                        new google.maps.Marker({
                            label: { text: String(count), color: "#ffffff", fontSize: "14px" },
                            position,
                            // adjust zIndex to be above other markers
                            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                            icon: {
                                url: `data:image/svg+xml;base64,${icon}`,
                                scaledSize: new google.maps.Size(45, 45),
                            }
                        }),
                }
            });

            return map;
        }


        /**
         * initMarker
         *
         * Creates a marker for the given jQuery element and map.
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   jQuery $el The jQuery element.
         * @return  object The marker instance.
         */
        initMarker = ($marker) => {
            // Get position from marker.
            const svgIcon = (color, scale = 1) => {
                const width = 28 * scale;
                const height = 34 * scale;

                return `
                <svg width="${width}" height="${height}" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 0.333252C7.00001 0.333252 0.666672 5.69992 0.666672 13.9999C0.666672 19.2585 4.68569 25.4352 12.7094 32.5445C13.4455 33.1967 14.5545 33.1967 15.2906 32.5445C23.3143 25.4352 27.3333 19.2585 27.3333 13.9999C27.3333 5.69992 21 0.333252 14 0.333252ZM14 16.9999C12.1667 16.9999 10.6667 15.4999 10.6667 13.6666C10.6667 11.8333 12.1667 10.3333 14 10.3333C15.8333 10.3333 17.3333 11.8333 17.3333 13.6666C17.3333 15.4999 15.8333 16.9999 14 16.9999Z" fill="${color}"/>
                </svg>`
            };

            const initialIconPath = svgIcon('#1E3869'); // Default color
            const initialSize = new google.maps.Size(28, 34);
            const initialAnchor = new google.maps.Point(14, 34); // Anchor at the bottom center

            const image = {
                url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(initialIconPath),
                size: initialSize,
                origin: new google.maps.Point(0, 0),
                anchor: initialAnchor
            };


            var lat = $marker.data('lat');
            var lng = $marker.data('lng');
            var postID = $marker.data('post-id');

            var latLng = {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            };

            // Create marker instance.
            var marker = new google.maps.Marker({
                position: latLng,
                map: this.map,
                icon: image,
            });

            // Append to reference for later use.
            this.map.markers.push(marker);

            google.maps.event.addListener(marker, 'click', function () {
                var activeTile = $('.m-church-tile[data-post-id="' + postID + '"]');

                $('.m-church-tile--active').removeClass('m-church-tile--active');

                activeTile.addClass('m-church-tile--active');

                $('.m-church-tiles__list').animate({
                    scrollTop: activeTile.position().top + $('.m-church-tiles__list').scrollTop() - 100 % (activeTile.height())
                }, 500);

                this.map.markers.forEach(function (otherMarker) {
                    if (otherMarker !== marker) {
                        otherMarker.setIcon({
                            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(initialIconPath),
                            size: initialSize,
                            origin: new google.maps.Point(0, 0),
                            anchor: initialAnchor,
                        });
                    }
                });

                const newColor = '#3379FF';
                const scaleFactor = 1.3;
                const newIconPath = svgIcon(newColor, scaleFactor);

                // Calculate the new width and height based on the scale factor
                const newWidth = 28 * scaleFactor;
                const newHeight = 34 * scaleFactor;

                const newAnchor = new google.maps.Point(newWidth / 2, newHeight);


                // Change the color of the marker when clicked
                var newIcon = {
                    url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(newIconPath), // Keep the same icon URL
                    size: new google.maps.Size(newWidth, newHeight), // Set new scaled size
                    origin: new google.maps.Point(0, 0),
                    // anchor: new google.maps.Point(0, 44),
                    anchor: newAnchor, // Center and bottom of the new scaled size
                };

                // Update the marker's icon
                marker.setIcon(newIcon);
            });
        }

        /**
         * centerMap
         *
         * Centers the map showing all markers in view.
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   object The map instance.
         * @return  void
         */
        centerMap = () => {

            // Create map boundaries from all map markers.
            var bounds = new google.maps.LatLngBounds();
            this.map.markers.forEach(function (marker) {
                bounds.extend({
                    lat: marker.position.lat(),
                    lng: marker.position.lng()
                });
            });

            let ne = bounds.getNorthEast();
            let sw = bounds.getSouthWest();
            let lat = ne.lat();
            let diff = lat - sw.lat();
            let newlat = lat + 136 * diff / $('.js-map').height();

            bounds.extend({
                lat: newlat,
                lng: ne.lng()
            });
            // Case: Single marker.
            if (this.map.markers.length == 0) {
                if (this.map.me) {
                    this.map.setCenter(this.map.me.getPosition());
                } else {
                    this.map.setCenter({
                        lat: 41.850033,
                        lng: -87.6500523
                    });

                    this.map.setZoom(6);
                }
                // Case: Single marker.
            } else if (this.map.markers.length == 1) {
                this.map.setCenter(bounds.getCenter());
                // Case: Multiple markers.
            } else {
                if (this.map.me) {
                    bounds.extend({
                        lat: this.map.me.position.lat(),
                        lng: this.map.me.position.lng()
                    });
                }
                this.map.fitBounds(bounds);
            }
        }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.google_map = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].google_map = new GoogleMap(_[i], opt);
            else
                ret = _[i].google_map[opt].apply(_[i].google_map, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.m-google-map').google_map();
});